import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import classnames from 'classnames';
import QdtComponent from './QdtComponent';

const styles = require('./KPIs-styles.css');

const KPIs = ({ className, location }) => (
  <>
    {location.pathname === '/current' && (
      <section className={classnames(styles.kpis, className)}>
        <div className={styles.kpiscontent}>
          <div className={styles.kpigroup}>
            <div className={styles.kpi}>
              <div className={styles.header}>GAMES PLAYED</div>
              <div className={styles.value}>
                <QdtComponent type="QdtKpi" props={{ cols: ["=Count({1<d_DateYear={'$(vYear)'}, n_MatchStatusCode={*} - {'0', '1', '2', '4'}>} DISTINCT n_MatchID)"] }} />
              </div>
              <div className={styles.footer}>
              OUT OF
                {' '}
                <QdtComponent type="QdtKpi" props={{ cols: ["=Count({1<d_DateYear={'$(vYear)'}>} DISTINCT n_MatchID)"] }} />
              </div>
            </div>
            <div className={styles.kpi}>
              <div className={styles.header}>POINTS SCORED</div>
              <div className={styles.value}>
                <QdtComponent type="QdtKpi" props={{ cols: ["=(sum({1<d_DateYear={'$(vYear)'}>} num#(c_Result1, '#####')) + sum({1<d_DateYear={'$(vYear)'}>} num#(c_Result2, '#####')))"] }} />
              </div>
              <div className={styles.footer}>
                <QdtComponent type="QdtKpi" props={{ cols: ["=num(((sum({1<d_DateYear={'$(vYear)'}>} num#(c_Result1, '#####')) + sum({1<d_DateYear={'$(vYear)'}>} num#(c_Result2, '#####')))) / Count({1<d_DateYear={'$(vYear)'}, n_MatchStatusCode={*} - {'0', '1', '2', '4'}>} DISTINCT n_MatchID),'#,##0.00')"] }} />
                {' '}
              AVG PER GAME
              </div>
            </div>
          </div>
          <div className={styles.kpigroup}>
            <div className={styles.kpi}>
              <div className={styles.header}>TRIES</div>
              <div className={styles.value}>
                <QdtComponent type="QdtKpi" props={{ cols: ["=count({1<TryFlag={1}, d_DateYear={'$(vYear)'}>} n_MatchActionID)"] }} />
              </div>
              <div className={styles.footer}>
                <QdtComponent type="QdtKpi" props={{ cols: ["=num(count({1<TryFlag={1}, d_DateYear={'$(vYear)'}>} n_MatchActionID) / Count({1<d_DateYear={'$(vYear)'}, n_MatchStatusCode={*} - {'0', '1', '2', '4'}>} DISTINCT n_MatchID),'#,##0.00')"] }} />
                {' '}
              AVG PER GAME
              </div>
            </div>
            <div className={styles.kpi}>
              <div className={styles.header}>CONVERSIONS</div>
              <div className={styles.value}>
                <QdtComponent type="QdtKpi" props={{ cols: ["=count({1<ConversionFlag={1}, d_DateYear={'$(vYear)'}>} n_MatchActionID)"] }} />
              </div>
              <div className={styles.footer}>
                <QdtComponent type="QdtKpi" props={{ cols: ["=num(count({1<ConversionFlag={1}, d_DateYear={'$(vYear)'}>} n_MatchActionID) / Count({1<d_DateYear={'$(vYear)'}, n_MatchStatusCode={*} - {'0', '1', '2', '4'}>} DISTINCT n_MatchID),'#,##0.00')"] }} />
                {' '}
              AVG PER GAME
              </div>
            </div>
          </div>
        </div>
      </section>
    )}
    {location.pathname === '/historical' && (
      <section className={classnames(styles.kpis, className)}>
        <div className={styles.kpiscontent}>
          <div className={styles.kpigroup}>
            <div className={styles.kpi}>
              <div className={styles.header}>TOURNAMENTS</div>
              <div className={styles.value}>
                <QdtComponent type="QdtKpi" props={{ cols: ['=Count({1<d_DateYear={*} - {\'$(vYear)\'}>} DISTINCT c_Edition)'] }} />
              </div>
              <div className={styles.footer}>
                <QdtComponent type="QdtKpi" props={{ cols: ['=Concat({1<d_DateYear={*} - {\'$(vYear)\'}>} distinct c_Edition, \', \')'] }} />
              </div>
            </div>
            <div className={styles.kpi}>
              <div className={styles.header}>WINNERS</div>
              <div className={styles.value}>
                <QdtComponent type="QdtKpi" props={{ cols: ['=Count({1} DISTINCT WinningTeam)'] }} />
              </div>
              <div className={styles.footer}>
                <QdtComponent type="QdtKpi" props={{ cols: ['=Concat({1} DISTINCT WinningTeam, \', \')'] }} />
              </div>
            </div>
          </div>
          <div className={styles.kpigroup}>
            <div className={styles.kpi}>
              <div className={styles.header}>BEST TEAM</div>
              <div className={styles.value}>
                <QdtComponent type="QdtKpi" props={{ cols: ['=FirstSortedValue({1} Aggr({1} Count({1} DISTINCT d_DateYear), WinningTeam), -Aggr({1} Count({1} DISTINCT d_DateYear), WinningTeam))'] }} />
              </div>
              <div className={styles.footer}>
                <div><QdtComponent type="QdtKpi" props={{ cols: ['=FirstSortedValue({1} DISTINCT WinningTeam, -Aggr({1} Count({1} DISTINCT d_DateYear), WinningTeam))'] }} /></div>
                <div><QdtComponent type="QdtKpi" props={{ cols: ['=FirstSortedValue({1} Aggr({1} Concat({1} DISTINCT d_DateYear, \', \'), WinningTeam), -Aggr({1} Count({1} DISTINCT d_DateYear), WinningTeam))'] }} /></div>
              </div>
            </div>
            <div className={styles.kpi}>
              <div className={styles.header}>CURRENT CHAMPION</div>
              <div className={styles.value}>
                {/* <div className={styles.text}><QdtComponent type="QdtKpi" props={{ cols: ['=Only({1<d_DateYear={\'$(=Max({1<WinningTeam={*}>} DISTINCT d_DateYear))\'}>} DISTINCT WinningTeam)'] }} /></div> */}
                <div className={styles.text}><QdtComponent type="QdtKpi" props={{ cols: ['=Only({1<d_DateYear={\'$(=Max({1<WinningTeam={*}>} DISTINCT d_DateYear))\'}>} DISTINCT WinningTeam)'] }} /></div>
              </div>
              <div className={styles.footer}>
                <QdtComponent type="QdtKpi" props={{ cols: ['=Max({1<WinningTeam={*}>} DISTINCT d_DateYear)'] }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    )}
  </>
);

KPIs.propTypes = {
  className: PropTypes.string,
  location: PropTypes.object.isRequired,
};
KPIs.defaultProps = {
  className: null,
};

export default withRouter(KPIs);
